// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__ANYkd","gradientOverlay":"style_gradientOverlay__XGTBI","innerGradient":"style_innerGradient__Htcns"};